import { useI18n } from "@core/i18n/i18n";
import { e2eTestId } from "@e2e/test-ids";
import styled from "@emotion/styled";
import { Button, ButtonProps } from "@ui/components/buttons/button";
import { BaseDialog, DIALOG_SIZE } from "@ui/components/dialog/base-dialog";
import { row } from "@ui/style";
import { DialogProps } from "primereact/dialog";
import React from "react";

interface ConfirmActionDialogProps extends DialogProps {
	title: string;
	message: string;
	onCancel?: () => void;
	onConfirm?: () => void;
	cancelButtonLabel?: string;
	confirmButtonLabel?: string;
	confirmButtonStyle?: ButtonProps["uiStyle"];
	confirmLoading?: boolean;
	width?: DIALOG_SIZE;
}

export const ConfirmActionDialog: React.FC<ConfirmActionDialogProps> = ({
	title,
	message,
	cancelButtonLabel,
	confirmButtonLabel,
	onCancel,
	onConfirm,
	confirmButtonStyle = "danger",
	confirmLoading,
	width = DIALOG_SIZE.S,
	...otherProps
}: ConfirmActionDialogProps) => {
	const { format } = useI18n();
	return (
		<BaseDialog
			header={title}
			footer={
				<ButtonContainer>
					<Button
						data-test={e2eTestId.confirmActionDialog.cancelButton}
						uiStyle="secondary"
						onClick={onCancel}
						label={cancelButtonLabel ?? format("global.dialog.cancel")}
					/>
					<Button
						data-test={e2eTestId.confirmActionDialog.yesButton}
						uiStyle={confirmButtonStyle}
						onClick={onConfirm}
						loading={confirmLoading}
						label={confirmButtonLabel ?? format("global.dialog.yes")}
					/>
				</ButtonContainer>
			}
			width={width}
			{...otherProps}
		>
			<p style={{ whiteSpace: "pre-line" }}>{message}</p>
		</BaseDialog>
	);
};

const ButtonContainer = styled.div`
	${row(24, "flexend")}
`;
